// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1yGAt","selects":"Documents_selects__KJeKk"};